import { render, staticRenderFns } from "./CatalogItemIconSelect.vue?vue&type=template&id=04f40feb&scoped=true&"
import script from "./CatalogItemIconSelect.vue?vue&type=script&lang=js&"
export * from "./CatalogItemIconSelect.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItemIconSelect.vue?vue&type=style&index=0&id=04f40feb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f40feb",
  null
  
)

export default component.exports